(function (root) {
  const DAY = 86400000;
  const calendarFormat = new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kuala_Lumpur', year: 'numeric', month: '2-digit', day: '2-digit', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' });
  let offset = 0;
  const clock = () => new Date(Date.now() + offset);
  // ponytail: Date header has 1s resolution, so the offset is +-1s; fine for hour-level slots
  const sync = async () => {
    try {
      const sent = Date.now();
      const response = await fetch((root.Shopify?.routes?.root || '/') + 'cart.js', { cache: 'no-store' });
      const server = Date.parse(response.headers.get('Date'));
      if (Number.isFinite(server)) offset = server - (sent + Date.now()) / 2;
    } catch (error) {}
  };
  const calendar = (now = clock()) => {
    const p = Object.fromEntries(calendarFormat.formatToParts(now).map(x => [x.type, x.value]));
    return { day: Date.UTC(+p.year, +p.month - 1, +p.day), minute: +p.hour * 60 + +p.minute };
  };
  const iso = day => new Date(day).toISOString().slice(0, 10);
  const parseDate = text => {
    if (!/^\d{4}-\d{2}-\d{2}$/.test(text || '')) return null;
    const n = Date.parse(text + 'T00:00:00Z');
    return Number.isFinite(n) && iso(n) === text ? n : null;
  };
  const parseDisplay = text => {
    const p = /^(\d{2})[-/](\d{2})[-/](\d{4})$/.exec(text || '');
    return p ? parseDate(`${p[3]}-${p[2]}-${p[1]}`) : null;
  };
  const minute = text => /^([01]\d|2[0-3]):[0-5]\d$/.test(text || '') ? +text.slice(0, 2) * 60 + +text.slice(3) : 0;
  const readiness = (rule, now = clock()) => {
    const current = calendar(now);
    const lead = Math.max(0, parseInt(rule.lead, 10) || 0);
    const cutoff = Number(rule.cutoff);
    const closed = cutoff > 0 && current.minute >= cutoff * 60;
    const normal = current.day + (lead + (closed ? 1 : 0)) * DAY;
    return { day: Math.max(normal, parseDate(rule.date) || 0), minute: minute(rule.ready), closed, lead, cutoff };
  };
  const blocks = text => {
    const result = { days: new Set(), slots: new Map() };
    for (const line of String(text || '').split('\n')) {
      const match = /^\s*(\d{2}\/\d{2}\/\d{4})(?:\s*-\s*(\d{2}\/\d{2}\/\d{4}))?(?:\s*:\s*(.+))?\s*$/.exec(line);
      if (!match) continue;
      const start = parseDisplay(match[1]), end = parseDisplay(match[2] || match[1]);
      if (start === null || end === null || end < start) continue;
      for (let day = start; day <= end && day < start + DAY * 3660; day += DAY) {
        if (!match[3]) result.days.add(day);
        else {
          const ranges = match[3].split(',').map(x => x.trim().split('-').map(Number)).filter(x => x.length === 2 && x.every(Number.isFinite) && x[0] < x[1]);
          result.slots.set(day, [...(result.slots.get(day) || []), ...ranges.map(x => x.map(h => h * 60))]);
        }
      }
    }
    return result;
  };
  const timeText = m => `${Math.floor(m / 60) % 12 || 12}${m % 60 ? ':' + String(m % 60).padStart(2, '0') : ''}${m < 720 ? 'AM' : 'PM'}`;
  const slots = (rules, day, blocked = blocks(''), now = clock()) => {
    const current = calendar(now);
    if (!Number.isFinite(day) || day < current.day || blocked.days.has(day) || !rules.length) return [];
    let from = 0;
    for (const rule of rules) {
      const ready = readiness(rule, now);
      if (day < ready.day) return [];
      if (day === ready.day) from = Math.max(from, ready.minute);
    }
    return [[660,780],[780,960],[960,1140],[1140,1260]].flatMap(([base, end]) => {
      const start = Math.max(base, from);
      if (start >= end || (day === current.day && current.minute >= start)) return [];
      if ((blocked.slots.get(day) || []).some(([a,b]) => start < b && end > a)) return [];
      return [{ start, end, key: `${start}-${end}`, label: `${timeText(start)} - ${timeText(end)}`, pickupOnly: false }];
    });
  };
  const earliest = (rules, blocked = blocks(''), now = clock()) => {
    if (!rules.length) return null;
    const first = Math.max(...rules.map(r => readiness(r, now).day));
    for (let day = first; day < first + DAY * 730; day += DAY) {
      const available = slots(rules, day, blocked, now);
      if (available.length) return { day, slot: available[0] };
    }
    return null;
  };
  const dateText = day => new Intl.DateTimeFormat('en-GB', { timeZone: 'UTC', day: 'numeric', month: 'short', year: 'numeric' }).format(new Date(day));
  const displayDate = day => iso(day).split('-').reverse().join('-');
  root.MiyabiAvailability = { DAY, clock, sync, calendar, iso, parseDate, parseDisplay, readiness, blocks, slots, earliest, timeText, dateText, displayDate };
  if (root.document) {
    sync();
    document.addEventListener('visibilitychange', () => { if (!document.hidden) sync(); });
  }
})(globalThis);
